import RcsCardPreview from 'components/messagePreview/components/RcsCardPreview';
import RcsCarouselPreview from 'components/messagePreview/components/RcsCarouselPreview';
import RcsTextPreview from 'components/messagePreview/components/RcsTextPreview';
import { MessageDirection } from 'components/messagePreview/types';
import { RcsMessageCategories } from 'constants/rcs';
import { RcsMessage } from 'types/rcs';

interface RcsPreviewProps {
  carouselOverflowSize?: string;
  direction?: MessageDirection;
  isLoading: boolean;
  message: RcsMessage;
}

const RcsPreview = ({
  carouselOverflowSize,
  direction,
  isLoading,
  message,
}: RcsPreviewProps) => {
  if (message.category === RcsMessageCategories.TEXT) {
    return (
      <RcsTextPreview
        direction={direction}
        isLoading={isLoading}
        message={message}
      />
    );
  }

  if (
    message.category === RcsMessageCategories.CARD &&
    message.cards.length > 0
  ) {
    return (
      <RcsCardPreview
        card={message.cards[0]}
        isLoading={isLoading}
        message={message}
      />
    );
  }

  if (
    message.category === RcsMessageCategories.CAROUSEL &&
    message.cards.length >= 2
  ) {
    return (
      <RcsCarouselPreview
        cards={message.cards}
        carouselOverflowSize={carouselOverflowSize}
        isLoading={isLoading}
        message={message}
      />
    );
  }

  return null;
};

export default RcsPreview;
